// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".NavSidebarCreateButton-menu__Mqz9B{width:calc(var(--size-44) + var(--size-2_5) + var(--size-0_25))}.NavSidebarCreateButton-subMenu__EV8Mg{width:var(--size-40)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menu": "NavSidebarCreateButton-menu__Mqz9B",
	"subMenu": "NavSidebarCreateButton-subMenu__EV8Mg"
};
export default ___CSS_LOADER_EXPORT___;
